/* ------------------------------------------ GRYFF FONT PICKER - T 08.09.2016 ----------------------------------------- */
import { POST } from '@/app/api/index';
import config from '@/app/editor/config';
import api from '@/app/endpoints.js';
import getQualityUploadCareImage from '@/app/utils/getQualityUploadCareImage';
import utils from '@/app/utils/gfUtils';
import hasImageUploadCare from '@/app/utils/hasImageUploadCare';
import HELPER from '@/app/utils/HELPER';
import { isURL } from '@/app/utils/helpers';
import replaceImageToQuality from '@/app/utils/replaceImageToQuality';
import replaceSpecialCharInImageName from '@/app/utils/replaceSpecialCharInImageName';
import emitter from '@/emitter';
import { GEM_METER_TRIGGER_EVENT } from '@/modules/gem-meter/constants';
import { app } from '@/store';

function ShowPopupLimit(jQuery) {
  const $divContentHidden = jQuery('#divContentHidden');
  $divContentHidden.append(`<div id="md-file-too-heavy"></div>`);
  const helpCenter = `https://help.gempages.net/articles/which-image-format-supported-by-gempages`;
  const _template =
    '<div class="bounder">' +
    '<h3 class="title">Your file is too heavy!</h3>' +
    '<p class="desc">Your file exceed maximum size (3MB)</p>' +
    '<p class="desc">Please crop or compress image/gif to reduce file size</p>' +
    '<div class="noti-info">' +
    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M7.99999 10.6706C7.54683 10.6706 7.17947 11.0379 7.17947 11.4911C7.17947 11.9443 7.54683 12.3116 7.99999 12.3116C8.45314 12.3116 8.8205 11.9443 8.8205 11.4911C8.8205 11.0379 8.45314 10.6706 7.99999 10.6706Z" fill="#3C67FF"/>' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M7.99999 2.87177C8.45314 2.87177 8.8205 3.23912 8.8205 3.69228V8.95724C8.8205 9.41039 8.45314 9.77775 7.99999 9.77775C7.54683 9.77775 7.17947 9.41039 7.17947 8.95724V3.69228C7.17947 3.23912 7.54683 2.87177 7.99999 2.87177Z" fill="#3C67FF"/>' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M12.4965 3.50353C10.0131 1.02019 5.98686 1.02019 3.50353 3.50353C1.02019 5.98686 1.02019 10.0131 3.50353 12.4965C5.98686 14.9798 10.0131 14.9798 12.4965 12.4965C14.9798 10.0131 14.9798 5.98686 12.4965 3.50353ZM2.34315 2.34315C5.46734 -0.781049 10.5327 -0.781049 13.6569 2.34315C16.781 5.46734 16.781 10.5327 13.6569 13.6569C10.5327 16.781 5.46734 16.781 2.34315 13.6569C-0.781049 10.5327 -0.781049 5.46734 2.34315 2.34315Z" fill="#3C67FF"/>' +
    '</svg>' +
    '<div class="noti-desc">' +
    '<p>You can upload image/gif on Shopify and link them to GemPages. Learn more in ' +
    '<a target="_blank" href="' +
    helpCenter +
    '">Help Center ' +
    '<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M4.5 2.5H2V10.5H10V8" stroke="#3C67FF"/>' +
    '<path d="M6.5 2.5H10.0001M10.0001 2.5L10 6M10.0001 2.5L5 7.5" stroke="#3C67FF"/>' +
    '</svg>' +
    '</a>' +
    '</p>' +
    '</div>' +
    '</div>' +
    '<button class="got-it" gf-action="gotIt">Got it</button>' +
    '</div>';
  const $modal = $divContentHidden.find('#md-file-too-heavy');
  $modal.gfModalNew({
    header: '',
    footer: '',
    width: 528,
    // 'height': 469,
    center: true,
    overlayClick: false,
    bg: 'rgba(0,0,0,0.7)',
    minimizedHeader: true,
    onContent: function ($content) {
      $content.html(_template);
      const $btnPrimary = $content.find(`.bounder [gf-action="gotIt"]`);
      $btnPrimary.off('click').on('click', function (e) {
        $modal.data('gfmodalnew').onClose();
        $modal.remove();
        e.preventDefault();
      });
    },
  });
  $modal.data('gfmodalnew').onShow();
}

// Vì biến này sử dụng cho 2 package `gfPhotoPickerPopup` và `gfPhotoPicker`
// Nên cần đặt biến global
let selectedQuality = 'lighter';
(function (jQuery) {
  jQuery.gfPhotoPickerPopup = function (element, options) {
    const defaults = {
      option: '',
      addHistory: true,
      onSelected: function (value) {},
      detectChange: function () {},
      onHistoryAdded: function () {},
    };
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;

    const _mdPhotoPicker = '<div id="md-photo-picker"></div>';

    let $photoPicker;
    let $photoPickerBody;
    let $activeModal;

    let timeOutMessage;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');
    const $divTopBar = jQuery('#divTopBar');
    const $divContentHidden = jQuery('#divContentHidden');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');

    const _uploadDomain = config.__DOMAIN_UPLOAD();

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      $photoPicker = $element.next('.gfPhotoPicker');
      $photoPickerBody = $photoPicker.find('.gfPhotoPickerBody');

      _this.showUploader({
        src: _this.settings.src,
        alt: _this.settings.alt,
      });
      return false;
    };

    this.showPopupLimit = function () {
      ShowPopupLimit(jQuery);
    };

    this.getApiImages = async function (callback) {
      const shop = $gfFrame.data('gfframe').getShopDomain();
      if (shop == '') {
        // shop = 'devgempagesnet'
      }
      const dataReq = {
        shop: shop,
        app_name: 'gempages',
      };
      try {
        const res = await POST(_uploadDomain + '/api/image/get', dataReq);
        const { data } = res;
        if (data.success) {
          callback(null, data.images, data.token);
        } else {
          callback(data.message);
        }
      } catch (err) {
        callback(err);
      }
    };

    this.formatSizeUnits = function (bytes) {
      if (bytes >= 1073741824) {
        bytes = (bytes / 1073741824).toFixed(2) + ' GB';
      } else if (bytes >= 1048576) {
        bytes = (bytes / 1048576).toFixed(2) + ' MB';
      } else if (bytes >= 1024) {
        bytes = (bytes / 1024).toFixed(2) + ' KB';
      } else if (bytes > 1) {
        bytes = bytes + ' bytes';
      } else if (bytes == 1) {
        bytes = bytes + ' byte';
      } else {
        bytes = '0 byte';
      }
      return bytes;
    };

    this.showMessageError = function (message) {
      /////////////////////////
      clearTimeout(timeOutMessage);
      $activeModal.find('.gfMDPhotoPickerError').html(message);
      $activeModal.find('.gfMDPhotoPickerError').addClass('show');
      timeOutMessage = setTimeout(function () {
        $activeModal.find('.gfMDPhotoPickerError').html('');
        $activeModal.find('.gfMDPhotoPickerError').removeClass('show');
      }, 4000);
    };

    this.showUploader = function (obj) {
      if ($divContentHidden.children('#md-photo-picker').length == 0) {
        $divContentHidden.append(_mdPhotoPicker);
        $activeModal = $divContentHidden.find('#md-photo-picker');
        // $activeModal.gfModal();
        $activeModal.gfModalNew({
          title: 'Choose Image...',
          header: 'noIcon',
          footer: '',
          left: $gfLeftSideBar.children().innerWidth(),
          top: $divTopBar.innerHeight(),
          width: 424,
          height: 550,
          background: '#fff',
          zIndex: '9999999',
          loading: true,
          onContent: function ($content) {
            _this.getApiImages(function (err, data, token) {
              if (err) {
                console.log(err);
                alert(
                  'There are errors from uploading server. Feel free to reach us on live chat for more information.',
                );
              } else {
                let html = '<div class="gfMDPhotoPicker" data-token="' + token + '">';
                html += '<div class="gfMDPhotoPickerError"></div>';
                html += '<div class="gfMDPhotoPickerBody">';
                html +=
                  '<div class="gfMDPhotoPickerUpload"><input type="file" /><svg class="help-me-name-it-bruh" height="20px" viewBox="0 0 20 20"><path d="M11,9h9v2h-9v9H9v-9H0V9h9V0h2V9z" style="fill: #BBBDCC" /></svg></div>';

                for (let i = 0; i < data.length; i++) {
                  const imageUrl = data[i].src;
                  let largeSrc = imageUrl;
                  let smallSrc = imageUrl;
                  //fix if type of image svg, gif
                  if (imageUrl.includes('preview/')) {
                    largeSrc = imageUrl + '-/resize/240x240/';
                    smallSrc = imageUrl + '-/resize/30x30/';
                  }

                  const imageName = data[i].alt.split('.');
                  const extendsImage = imageName.pop();
                  let srtName =
                    imageName[0].substr(0, 7) +
                    '...' +
                    imageName[imageName.length - 1].substr(imageName.length - 5, 5) +
                    '.' +
                    extendsImage;

                  html += '<div class="gfMDPhotoPickerItem">';
                  let alt = data[i].alt;
                  // replace name info
                  srtName = replaceSpecialCharInImageName(srtName);
                  // replace alt for link
                  alt = replaceSpecialCharInImageName(data[i].alt);
                  const dataSeoUrl = data[i].alt ? data[i].src + encodeURI(alt) : data[i].src;
                  html +=
                    '<img class="gfMDPhotoPickerLazy" data-seo-url="' +
                    dataSeoUrl +
                    '" data-src="' +
                    imageUrl +
                    '" data-count="' +
                    i +
                    '" src="' +
                    largeSrc +
                    '" />';
                  html += '<img class="gfMDPhotoPickerSmall" src="' + smallSrc + '" />';
                  html += '<div class="gfMDPPItemInfo">';
                  html += '<p class="name">' + srtName + '</p>';
                  html += '<p>' + _this.formatSizeUnits(data[i].size) + '</p>';
                  html +=
                    '<span class="rm"><svg class="help-me-name-it-bruh" height="13px" viewBox="0 0 7 13"><path d="M4,5h1v4H4V5z M2,5h1v4H2V5z M3,1V0h1v1h3v1H0V1H3z M1,10h5V4H1V10z M1,11H0V3h1h5h1v8H6H1z" style="fill: rgba(255,255,255,0.9);" /></svg></span>';
                  html += '</div>';
                  html +=
                    '<div class="gfMDPPConfirm"><p>Delete image?</p><span class="yes" data-id="' +
                    data[i].id +
                    '" >Yes</span><span class="no">No</span></div>';
                  html += '</div>';
                }
                html += '</div>';
                html += '</div>';

                $content.html(html);
                $activeModal.data('gfmodalnew').offLoading();
                // Lazy load images
                $content.find('.gfMDPhotoPickerLazy').on('load', function () {
                  $(this).css({
                    display: 'block',
                  });
                  $(this).next('.gfMDPhotoPickerSmall').css({
                    display: 'none',
                  });
                });

                $content.find('.gfMDPhotoPickerBody').addClass('optiscroll').optiscroll();

                $content
                  .find('.gfMDPhotoPickerUpload input')
                  .off('change')
                  .on('change', function () {
                    const that = this;
                    const img = this.files[0];

                    if (this.files && this.files[0]) {
                      if (img.size && img.size > 3 * 1024 * 1024) {
                        _this.showPopupLimit();
                      } else {
                        const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.svg|\.webp|\.avif)$/i;
                        if (!allowedExtensions.exec(img.name)) {
                          HELPER.showNotify(
                            'Failed to upload... Images type no support. Please upload file having extensions .jpeg/.jpg/.png/.gif/.svg/.webp/.avif only.',
                            'error',
                          );
                          _this.showMessageError(
                            'Failed to upload... Images type no support. Please upload file having extensions .jpeg/.jpg/.png/.gif/.svg/.webp/.avif only.',
                          );
                          that.value = '';
                        } else {
                          const urlImages = window.URL.createObjectURL(img);
                          let htmlUpload = '<div class="gfMDPhotoPickerItem uploading">';
                          htmlUpload += '<img class="gfMDPhotoPickerLazy" src="' + urlImages + '" />';
                          htmlUpload += '<div class="gfMDPhotoPickerLoadingBg"></div>';
                          htmlUpload += '<div class="gfMDPhotoPickerLoading"><span></span></div>';
                          htmlUpload += '</div>';
                          $content.find('.gfMDPhotoPickerUpload').after(htmlUpload);
                          const $itemLoader = $content.find('.gfMDPhotoPickerUpload').next('.uploading');
                          $itemLoader.find('.gfMDPhotoPickerLazy').css({
                            display: 'block',
                          });
                          // Upload API
                          $($itemLoader)
                            .find('.gfMDPhotoPickerLoading span')
                            .css({
                              width: '0px',
                            })
                            .animate(
                              {
                                width: '25%',
                              },
                              10000,
                            )
                            .animate(
                              {
                                width: '50%',
                              },
                              20000,
                            )
                            .animate(
                              {
                                width: '75%',
                              },
                              30000,
                            );

                          const shop = $gfFrame.data('gfframe').getShopDomain();
                          if (shop == '') {
                            // shop = 'devgempagesnet'
                          }
                          const formData = new FormData();
                          // thay đổi name file khi upload
                          formData.append('file', img, replaceSpecialCharInImageName(img.name));

                          formData.append('shop', shop);
                          formData.append('app_name', 'gempages');

                          const req = api.uploadImage();

                          POST(_uploadDomain + req.url, formData, 'json', false, false)
                            .then((res) => {
                              const data = res.data;
                              if (data.success) {
                                // ===== GemMeter Feature ===== //
                                app.$store.commit('gemMeter/ADD_GEMPAGES_IMAGE', {
                                  src: data.url,
                                  size: data.size,
                                });
                                // ==================== //
                                const imageUrl = data.url;
                                const largeSrc = imageUrl + '-/resize/240x240/';
                                const smallSrc = imageUrl + '-/resize/30x30/';

                                const imageName = data.name.split('.');
                                const extendsImage = imageName.pop();
                                const srtName =
                                  imageName[0].substr(0, 7) +
                                  '...' +
                                  imageName[imageName.length - 1].substr(imageName.length - 5, 5) +
                                  '.' +
                                  extendsImage;

                                let html = '<div class="gfMDPPItemInfo">';
                                html += '<p class="name">' + srtName + '</p>';
                                html += '<p>' + _this.formatSizeUnits(data.size) + '</p>';
                                html +=
                                  '<span class="rm"><svg class="help-me-name-it-bruh" height="13px" viewBox="0 0 7 13"><path d="M4,5h1v4H4V5z M2,5h1v4H2V5z M3,1V0h1v1h3v1H0V1H3z M1,10h5V4H1V10z M1,11H0V3h1h5h1v8H6H1z" style="fill: rgba(255,255,255,0.9);" /></svg></span>';
                                html += '</div>';
                                html +=
                                  '<div class="gfMDPPConfirm"><p>Delete image?</p><span class="yes" data-id="' +
                                  data.id +
                                  '">Yes</span><span class="no">No</span></div>';

                                const dataSeoUrl = data.name ? data.url + encodeURI(data.name) : data.url;
                                $itemLoader.find('.gfMDPhotoPickerLazy').attr('data-seo-url', dataSeoUrl);

                                $itemLoader.find('.gfMDPhotoPickerLazy').attr('data-src', data.url);
                                $itemLoader.find('.gfMDPhotoPickerLazy').after(html);
                                $($itemLoader)
                                  .find('.gfMDPhotoPickerLoading span')
                                  .stop(true, false)
                                  .animate(
                                    {
                                      width: 100 + '%',
                                    },
                                    1000,
                                    function () {
                                      $itemLoader.find('.gfMDPhotoPickerLoadingBg').remove();
                                      $itemLoader.find('.gfMDPhotoPickerLoading').remove();
                                      $itemLoader.removeClass('uploading');
                                      // Success
                                      $content.find('.gfMDPhotoPickerUpload input').val('');
                                      _this.onEventClickModal();
                                    },
                                  );
                              } else {
                                $($itemLoader)
                                  .find('.gfMDPhotoPickerLoading span')
                                  .addClass('error')
                                  .stop(true, false)
                                  .animate(
                                    {
                                      width: 100 + '%',
                                    },
                                    500,
                                  );

                                $content.find('.gfMDPhotoPickerUpload input').val('');

                                setTimeout(function () {
                                  $itemLoader.remove();

                                  if (data.message != undefined) {
                                    HELPER.showNotify(data.message, 'error');
                                    _this.showMessageError(data.message);
                                  } else {
                                    HELPER.showNotify('Failed to upload... Please try again later.', 'error');
                                    _this.showMessageError('Failed to upload... Please try again later.');
                                  }
                                }, 2000);
                              }
                            })
                            .catch((err) => {
                              $($itemLoader)
                                .find('.gfMDPhotoPickerLoading span')
                                .addClass('error')
                                .stop(true, false)
                                .animate(
                                  {
                                    width: 100 + '%',
                                  },
                                  500,
                                );

                              $content.find('.gfMDPhotoPickerUpload input').val('');

                              setTimeout(function () {
                                $itemLoader.remove();
                                HELPER.showNotify('Failed to upload... Please try again later.', 'error');
                                _this.showMessageError('Failed to upload... Please try again later.');
                              }, 2000);
                            });
                        }
                      }
                    }
                  });
                _this.onEventClickModal();
              }
            });
          },
          onCancel: function () {
            $activeModal.data('gfmodalnew').onClose();
            $activeModal.remove();
          },
        });

        $activeModal.data('gfmodalnew').onShow();
      } else {
        $activeModal = $divContentHidden.find('#md-photo-picker');
        $activeModal.data('gfmodalnew').onShow();
        _this.onEventClickModal();
      }

      return false;
    };

    this.onEventClickModal = function () {
      $activeModal
        .find('.gfMDPhotoPickerItem')
        .off('click')
        .on('click', function (e) {
          if (
            jQuery(e.target).closest('.rm').length == 0 &&
            jQuery(e.target).closest('.yes').length == 0 &&
            jQuery(e.target).closest('.no').length == 0
          ) {
            $photoPickerBody.addClass('onImage');

            let src;
            src = $(this).find('.gfMDPhotoPickerLazy').attr('data-seo-url');
            src = replaceSpecialCharInImageName(src);

            // Sau khi lụa chọn image trong list image uploadcare
            // -> get src image theo quality selected
            src = replaceImageToQuality(src, selectedQuality);

            $photoPickerBody.children('img').remove();
            $photoPickerBody.css('background-image', 'url(' + src + ')').prepend('<img src="' + src + '"/>');
            $activeModal.data('gfmodalnew').onClose();
            const data = {
              src: src,
            };

            $photoPickerBody.children('img').remove();
            $photoPickerBody.css('background-image', 'url(' + data.src + ')').prepend('<img src="' + data.src + '" />');

            // update
            $element.attr('value', data.src).val(data.src).trigger('image-change').trigger('input-change');
            _this.settings.onHistoryAdded();
            if (_this.settings.addHistory) {
              $element.trigger('history-change');
            }
            $element.data('gfphotopicker').setLinkSrc(data.src);

            if (_this.settings.detectChange) {
              _this.settings.detectChange();
            }
            // ===== GemMeter Feature ===== //
            emitter.emit('gem-meter:trigger-rules', GEM_METER_TRIGGER_EVENT.PAGE_SETTING_LAZY_LOAD);
            // ============================== //
            $activeModal.data('gfmodalnew').onClose();
          }
        });
      $activeModal
        .find('.rm')
        .off('click')
        .on('click', function () {
          const $dad = $(this).parents('.gfMDPhotoPickerItem');
          $dad.find('.gfMDPPItemInfo').animate(
            {
              left: '-100%',
            },
            200,
          );
          $dad.find('.gfMDPPConfirm').animate(
            {
              left: '0px',
            },
            200,
          );

          $dad
            .find('.gfMDPPConfirm .yes')
            .off('click')
            .on('click', function () {
              const value = $dad.find('.gfMDPhotoPickerLazy').attr('data-src');
              const token = $activeModal.find('.gfMDPhotoPicker').attr('data-token');
              const id = $(this).attr('data-id');
              const shop = $gfFrame.data('gfframe').getShopDomain();

              $($dad).remove();
              const data = {
                shop: shop,
                app_name: 'gempages',
                uploadcare_id: id,
                token: token,
              };

              POST(_uploadDomain + '/api/image/remove', data)
                .then((res) => {
                  if (res.data.success) {
                    if (value.split('?')[0] == $element.attr('value').split('?')[0]) {
                      _this.clearSrc();
                    }
                  } else {
                    HELPER.showNotify('Failed to remove... Please try again later.', 'error');
                  }
                })
                .catch((err) => {});
            });
          $dad
            .find('.gfMDPPConfirm .no')
            .off('click')
            .on('click', function () {
              $dad.find('.gfMDPPItemInfo').animate(
                {
                  left: '0px',
                },
                200,
              );
              $dad.find('.gfMDPPConfirm').animate(
                {
                  left: '100%',
                },
                200,
              );
            });
        });
    };

    this.init();
  };
  jQuery.fn.gfPhotoPickerPopup = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfphotopickerpopup')) {
        const plugin = new jQuery.gfPhotoPickerPopup(this, options);
        jQuery(this).data('gfphotopickerpopup', plugin);
      }
    });
  };
})(jQuery);

(function (jQuery) {
  jQuery.gfPhotoPicker = function (element, options) {
    const defaults = {
      option: '',
      title: '',
      addHistory: true,
      onSelected: function () {},
      detectChange: function () {},
      onHistoryAdded: function () {},
    };
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    let $photoPickerBody;

    const _uploadDomain = config.__DOMAIN_UPLOAD();

    const _templateOpenGallery = '<div class="gfPhotoPickerGallery">or <a class="op">Browse gallery</a></div>';
    let _templateInput = '<div class="gfPhotoPickerLink">';
    _templateInput += '<div class="gfSGSubTitle">Image Src</div>';
    _templateInput += '<div class="gfSGclear"></div>';
    _templateInput +=
      '<div class="gfPhotoPickerLinkIcon"><svg class="help-me-name-it-bruh" height="22px" viewBox="0 0 22 22"><path d="M5,5h1v7H5V5z M7,5h1v7H7V5z M15.5,5c0.1,0,0.3,0,0.4,0.1C16,5.2,16,5.4,16,5.5v6c0,0.1,0,0.3-0.1,0.3C15.8,12,15.6,12,15.5,12h-6c-0.1,0-0.3,0-0.3-0.1C9.1,11.8,9,11.6,9,11.5v-6c0-0.1,0-0.3,0.1-0.3C9.2,5,9.4,5,9.5,5H15.5z M10,11h5l-1.6-2.1l-1.3,1.6l-0.9-1.1L10,11z" style="fill: rgba(255,255,255,0.8);" /></svg></div>';
    _templateInput +=
      '<input type="text" placeholder="Link" class="gfPPInput" /><div class="clear">' +
      utils.svgIcon('clear') +
      '</div></div>';

    const imageQuality = [
      {
        value: 'lighter',
        label: 'Lighter',
      },
      {
        value: 'lightest',
        label: 'Lightest',
      },
    ];

    let $openGallery = jQuery(_templateOpenGallery + _templateInput);

    // Thêm setting lựa chọn `Image Quality`
    let _templateQuality = '<div class="gfImageQualitySelect">';
    _templateQuality += '<div class="gfSGSubTitle">Image Quality</div>';
    _templateQuality += '<div class="gfSGclear"></div>';
    _templateQuality += '<div class="gfFSRight">';
    _templateQuality +=
      '<select value="' +
      selectedQuality +
      '" name="image-quality" data-disable="false" data-description="Only support for UCare CDN">';
    for (let i = 0; i < imageQuality.length; i++) {
      _templateQuality += '<option value="' + imageQuality[i].value + '">' + imageQuality[i].label + '</option>';
    }
    _templateQuality += '</select>';
    _templateQuality += '</div>';

    $openGallery = jQuery(_templateOpenGallery + _templateInput + _templateQuality);

    const _mdPhotoPicker = '<div id="md-photo-picker"></div>';

    let _templateFormUpload = '<div class="gfPhotoPickerUpload">';
    _templateFormUpload += '<div class="gfPhotoPickerFormUpload">';
    _templateFormUpload += '<input type="file" name="upload_image" class="gfForm"/>';
    _templateFormUpload += '</div></div>';

    const $upload = jQuery(_templateFormUpload);
    let $photoPicker;

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      $element.hide();

      let _template = '<div class="gfPhotoPicker">';
      if (_this.settings.title == '') {
        _template += '<div class="gfSGSubTitle" data-title="none">' + _this.settings.title + '</div>';
        _template += '<div class="gfSGclear"></div>';
      } else {
        _template += '<div class="gfSGSubTitle">' + _this.settings.title + '</div>';
        _template += '<div class="gfSGclear"></div>';
      }
      _template += '<div class="gfPhotoPickerBody">';
      _template += '<div class="gfPhotoPickerBackground"></div>';
      _template += '<a class="gfPhotoPickerOverlay"><i>' + utils.svgIcon('upload') + ' Replace Image</i></a>';
      _template += '<span>' + utils.svgIcon('upload') + ' Upload image</span>';
      _template +=
        '<a href="#" class="rm"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.4966 7.50336C16.7746 7.78135 16.7746 8.23207 16.4966 8.51007L13.0067 12L16.4966 15.4899C16.7746 15.7679 16.7746 16.2186 16.4966 16.4966C16.2186 16.7746 15.7679 16.7746 15.4899 16.4966L12 13.0067L8.51007 16.4966C8.23207 16.7746 7.78135 16.7746 7.50336 16.4966C7.22536 16.2186 7.22536 15.7679 7.50336 15.4899L10.9933 12L7.50336 8.51007C7.22536 8.23207 7.22536 7.78135 7.50336 7.50336C7.78135 7.22536 8.23207 7.22536 8.51007 7.50336L12 10.9933L15.4899 7.50336C15.7679 7.22536 16.2186 7.22536 16.4966 7.50336Z" fill="#F2F3F4"/></svg></a>';
      _template += '</div>';
      _template += '</div>';

      $element.after(_template);
      $photoPicker = $element.next('.gfPhotoPicker');

      $photoPickerBody = $photoPicker.find('.gfPhotoPickerBody');
      $photoPicker.after($openGallery);

      let oldSrc = $element.attr('value');
      if (!oldSrc) {
        oldSrc = $element.attr('default_value');
      }

      // Find element select + set value quality of image vào select
      const $gfImageQualitySelect = $photoPicker.parent().find('.gfImageQualitySelect');
      selectedQuality = getQualityUploadCareImage(oldSrc) || 'lighter';
      $gfImageQualitySelect
        .find('select[name="image-quality"]')
        .attr('value', selectedQuality)
        .val(selectedQuality)
        .trigger('input-change');
      // Khởi chạy dropdown + SET value selected
      $gfImageQualitySelect.find('select').gfDropDown({
        onSelected: function (value) {
          // Get src element hiện tại
          let src = $element.closest('.gfSGSettings').find('.gfPPInput').val();
          // Set value selected
          $gfImageQualitySelect
            .find('select[name="image-quality"]')
            .attr('value', value)
            .val(value)
            .trigger('input-change');
          selectedQuality = value;

          src = replaceImageToQuality(src, selectedQuality);
          _this.display(src);
        },
      });

      const altTag = $element.closest('#md-settings').find('input[name="alt-tag"]').val();

      _this.setValue(oldSrc, altTag);
      _this.onEvent();

      $element.on('value-change', function () {
        const value = jQuery(this).attr('value');
        const altTag = $element.closest('#md-settings').find('input[name="alt-tag"]').val();
        _this.setValue(value, altTag);
      });

      $element.on('require-hide', function () {
        $openGallery.hide();
        $upload.hide();
      });
      $element.on('require-show', function () {
        $openGallery.show();
        $upload.show();
      });

      return false;
    };

    this.displayImageQualitySelect = function (src) {
      const $imageQualitySelect = $element.next('.gfPhotoPicker').parent().find('.gfImageQualitySelect');
      if (hasImageUploadCare(src) && getQualityUploadCareImage(src)) {
        $imageQualitySelect.find('select').data('gfdropdown').enable();
      } else {
        $imageQualitySelect.find('select').data('gfdropdown').disable();
      }
      return;
    };

    this.showPopupLimit = function () {
      ShowPopupLimit(jQuery);
    };

    this.setValue = function (oldSrc, altTag) {
      if (!altTag) {
        altTag = '';
      }
      $element.attr('value', oldSrc).val(oldSrc);
      if (oldSrc === '') {
        // _this.clearSrc();
        $photoPickerBody.css('background-image', 'none').removeClass('onImage').children('img').remove();
        _this.setLinkSrc('');
        _this.settings.detectChange();
      }
      if (oldSrc) {
        // Đọc link image từ element gán vào setting
        oldSrc = replaceSpecialCharInImageName(oldSrc);
        $photoPickerBody.addClass('onImage');
        const img = new Image();
        img.onload = function () {
          $photoPickerBody.children('img').remove();
          $photoPickerBody
            .css('background-image', 'url(' + oldSrc.replace('../', '') + ')')
            .prepend('<img src="' + oldSrc.replace('../', '') + '"/>');

          _this.setLinkSrc(oldSrc.replace('../', ''));
        };
        img.src = oldSrc.replace('../', '');
      }

      return false;
    };

    this.display = function (src, blur) {
      src = replaceSpecialCharInImageName(src);
      if (blur == undefined) {
        blur = false;
      }
      $upload.children('.gfPhotoPickerFormUpload').children().not('input[name="upload_image"]').remove();
      if (src.indexOf('../images/') == 0) src = src.replace('../images/', 'images/');
      const img = new Image();
      img.onload = function () {
        $photoPicker = $element.next('.gfPhotoPicker');
        $photoPickerBody = $photoPicker.find('.gfPhotoPickerBody');

        const $display = jQuery('<div/>').addClass('img-wrap');
        if (this.width > $upload.width() && this.height > $upload.height()) {
          $display.css('background-size', 'cover');
        }
        $photoPickerBody.addClass('onImage');
        if (blur) {
          $display
            .css({
              'background-image': 'url(' + src + ')',
            })
            .appendTo($upload.children('.gfPhotoPickerFormUpload'));
          $upload.find('.gfPhotoPickerFormUpload').append('<div class="gfPPUploadBg"></div>');
        } else {
          $upload.remove();
          $photoPickerBody.children('img').remove();
          $photoPickerBody.css('background-image', 'url(' + src + ')').prepend('<img src="' + src + '"/>');
          $photoPickerBody.show();
          _this.setLinkSrc(src);
          // Change value
          $element.val(src).attr('value', src).trigger('image-change').trigger('input-change');
          _this.settings.onHistoryAdded();
          if (_this.settings.addHistory) {
            $element.trigger('history-change');
          }
        }
      };
      img.src = src;

      // set val
      const $activeModal = $upload.closest('.md-modal');
      $activeModal.find('[name="imageSrc"]').val(src).attr('value', src).trigger('change');
      return false;
    };

    this.upload = function (img, callback) {
      if (img.type == '') {
        HELPER.showNotify('Oops! Your file format is not allowed.', 'error');
        $photoPickerBody.show();
        $upload.remove();
      } else if (img.size > 3 * 1024 * 1024) {
        _this.showPopupLimit();
        $photoPickerBody.show();
        $upload.remove();
      } else if (
        img.type == 'image/jpeg' ||
        img.type == 'image/png' ||
        img.type == 'image/gif' ||
        img.type == 'image/jpg' ||
        img.type == 'image/webp' ||
        img.type == 'image/avif' ||
        img.type == 'image/svg+xml'
      ) {
        //upload base64 src
        const urlImages = window.URL.createObjectURL(img);

        _this.display(urlImages, true);

        $upload.children('.gfPhotoPickerFormUpload').children().not('input[name="upload_image"]').remove();
        const $progressbar = jQuery(
          '<div class="gfPhotoPickerProgressbar"><div class="gfPhotoPickerProgressbarValue" style="width:0"></div></div>',
        ).appendTo($upload.addClass('uploading').children('.gfPhotoPickerFormUpload'));
        const fW = $progressbar.width();

        $progressbar
          .css('width', fW)
          .children('.gfPhotoPickerProgressbarValue')
          .css('width', 0)
          .animate(
            {
              width: fW * 0.25 + 'px',
            },
            100,
          )
          .animate(
            {
              width: fW * 0.5 + 'px',
            },
            1500,
          )
          .animate(
            {
              width: fW * 0.75 + 'px',
            },
            5000,
          );
        const shop = $gfFrame.data('gfframe').getShopDomain();
        if (shop == '') {
          // shop = 'devgempagesnet'
        }
        const formData = new FormData();
        // thay đổi name file khi upload
        formData.append('file', img, replaceSpecialCharInImageName(img.name));
        formData.append('shop', shop);
        formData.append('app_name', 'gempages');

        const req = api.uploadImage();
        POST(_uploadDomain + req.url, formData, 'json', false, false)
          .then((res) => {
            const data = res.data;
            if (data.success) {
              let seoUrl = data.url;
              seoUrl = data.name ? data.url + encodeURI(data.name) : data.url;
              // ===== GemMeter Feature ===== //
              app.$store.commit('gemMeter/ADD_GEMPAGES_IMAGE', {
                ...data,
                src: data.url,
                size: data.size,

              });
              // ==================== //
              //vì link ảnh này được cập nhật thẳng vào trong display và hiển thị => cần đổi quality
              seoUrl = replaceImageToQuality(seoUrl, selectedQuality);

              $progressbar
                .children('.gfPhotoPickerProgressbarValue')
                .stop(true, false)
                .animate(
                  {
                    width: fW * 0.85 + 'px',
                  },
                  10000,
                )
                .animate(
                  {
                    width: fW * 0.95 + 'px',
                  },
                  30000,
                );
              const img = new Image();
              img.onload = function () {
                $progressbar
                  .children('.gfPhotoPickerProgressbarValue')
                  .stop(true, false)
                  .animate(
                    {
                      width: fW + 'px',
                    },
                    1000,
                    function () {
                      $progressbar.hide();

                      _this.display(seoUrl, false);

                      // ===== GemMeter Feature ===== //
                      setTimeout(() => {
                        emitter.emit('gem-meter:trigger-rules', GEM_METER_TRIGGER_EVENT.PAGE_SETTING_LAZY_LOAD);
                      }, 500);
                      // ============================== //
                    },
                  );
              };
              img.src = seoUrl;
              callback();
            } else {
              $progressbar.addClass('error').children('.gfPhotoPickerProgressbarValue').stop(true, false);
              setTimeout(function () {
                $upload
                  .children('.gfPhotoPickerFormUpload')
                  .children()
                  .not('input[name="upload_image"]')
                  .not('div[class="img-wrap"]')
                  .remove();
                $upload.removeClass('uploading');
                const srcimg = $($element).attr('value');
                $upload.find('.img-wrap').css({
                  'background-image': 'url(' + srcimg + ')',
                });

                if (data.message != undefined) {
                  HELPER.showNotify(data.message, 'error');
                } else {
                  HELPER.showNotify('Failed to upload... Please try again later.', 'error');
                }
              }, 1000);
            }
          })
          .catch((err) => {
            $progressbar.addClass('error').children('.gfPhotoPickerProgressbarValue').stop(true, false);
            setTimeout(function () {
              $upload
                .children('.gfPhotoPickerFormUpload')
                .children()
                .not('input[name="upload_image"]')
                .not('div[class="img-wrap"]')
                .remove();
              $upload.removeClass('uploading');
              const srcimg = $($element).attr('value');
              $upload.find('.img-wrap').css({
                'background-image': 'url(' + srcimg + ')',
              });

              HELPER.showNotify('Failed to upload... Please try again later.', 'error');
            }, 1000);
          });
      } else {
        HELPER.showNotify('Failed to upload... No images data.', 'error');
        $photoPickerBody.show();
        $upload.remove();
      }
      return false;
    };

    this.setLinkSrc = function (src) {
      $element.closest('.gfSGSettings').find('.gfPPInput').val(src);
      _this.settings.onSelected(src, $element);
      //mỗi khi cập nhật lại link ở input thì check xem có ẩn hiện quality select
      this.displayImageQualitySelect(src);
    };

    this.clearSrc = function (link) {
      if (link == undefined) {
        link = true;
      }
      $photoPickerBody.css('background-image', 'none').removeClass('onImage').children('img').remove();
      if (link) {
        _this.setLinkSrc('');
      }
      $element.val('').attr('value', '');
      _this.settings.detectChange();
    };

    this.onEvent = function () {
      $photoPickerBody.off('click').on('click', function (e) {
        if (
          !jQuery(e.target).hasClass('rm') &&
          jQuery(e.target).closest('.rm').length == 0 &&
          !jQuery(e.target).hasClass('gfPhotoPickerGallery') &&
          jQuery(e.target).closest('.gfPhotoPickerGallery').length == 0
        ) {
          $photoPicker.next('.gfPhotoPickerUpload').remove();
          $photoPicker.after($upload);
          const $uploader = $photoPicker.next('.gfPhotoPickerUpload');
          $uploader.hide();
          $uploader.find('input').click();
          $upload
            .find('input[name="upload_image"]')
            .off()
            .on('change', function () {
              const _that = this;

              if (this.files && this.files[0]) {
                $photoPickerBody.hide();
                $uploader.show();
                _this.upload(this.files[0], function () {
                  _that.value = '';
                });
              }
            });
        }
      });

      $openGallery
        .find('.op')
        .off('click')
        .on('click', function () {
          if ($element.data('gfphotopickerpopup')) {
            $element.data('gfphotopickerpopup').showUploader({
              src: $gfLeftSideBar.find('#md-settings').find('input[name="image"]').val(),
              alt: $gfLeftSideBar.find('#md-settings').find('input[name="alt-tag"]').val(),
            });
          } else {
            $element.gfPhotoPickerPopup({
              src: $gfLeftSideBar.find('#md-settings').find('input[name="image"]').val(),
              alt: $gfLeftSideBar.find('#md-settings').find('input[name="alt-tag"]').val(),
              onHistoryAdded: function () {
                _this.settings.onHistoryAdded();
              },
            });
          }
        });

      $photoPickerBody
        .children('.rm')
        .off('click')
        .on('click', function () {
          $photoPickerBody.removeClass('onImage');
          _this.clearSrc();
          $element.trigger('input-change');
          _this.settings.onHistoryAdded();
          if (_this.settings.addHistory) {
            $element.trigger('history-change');
          }
          return false;
        });

      $openGallery
        .find('.clear')
        .off('click')
        .on('click', function () {
          _this.clearSrc();
          $element.trigger('input-change');
          _this.settings.onHistoryAdded();
          if (_this.settings.addHistory) {
            $element.trigger('history-change');
          }
        });

      let delayType;
      $openGallery
        .find('.gfPPInput')
        .off('change keyup paste')
        .on('change keyup paste', function (e) {
          // When click ctrl or command, do nothing
          if (e.type == 'keyup' && (e.which == 17 || e.which == 91)) {
            return;
          }
          if (e.type == 'change') {
            // Cache biến screenType vào window.GemCurrentScreenTypePhotoPicker để kiểm tra khi thay đổi có thay đổi đúng màn hình không.
            // Fix lỗi khi thay đổi ảnh ở laptop xog bấm chuyển màn hình sang mobile thì bị nhận dữ liệu cho mobile vì thuộc tính change bị chậm
            window.GemCurrentScreenTypePhotoPicker =
              jQuery('#gfResTool').data('gfrestool') != undefined
                ? jQuery('#gfResTool').data('gfrestool').getCurrentStatus()
                : 'lg';
          }
          clearTimeout(delayType);
          let src = $(this).val();

          if (e.type == 'paste') {
            const clipboardData = e.clipboardData || e.originalEvent.clipboardData || window.clipboardData;
            const clipboardText = clipboardData.getData('text');
            if (isURL(clipboardText)) {
              src = clipboardText;
            }
          }
          // paste link có ký tự đặc biệt
          src = replaceSpecialCharInImageName(src);

          /**
           * Sau khi paste link
           * Sửa lại Quality theo selectedQuality
           */
          src = replaceImageToQuality(src, selectedQuality);

          delayType = setTimeout(function () {
            const img = new Image();
            img.onload = function () {
              _this.display(src);
            };
            img.onerror = function () {
              _this.clearSrc(false);
              $element.trigger('input-change');
              _this.settings.onHistoryAdded();
              if (_this.settings.addHistory) {
                $element.trigger('history-change');
              }
            };
            img.src = src;
            $element.attr('value', src).val(src).trigger('image-change').trigger('input-change');
            _this.settings.onSelected(src, $element);
          }, 200);
        });
    };

    this.init();
  };
  jQuery.fn.gfPhotoPicker = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfphotopicker')) {
        const plugin = new jQuery.gfPhotoPicker(this, options);
        jQuery(this).data('gfphotopicker', plugin);
      }
    });
  };
})(jQuery);
